export const CA_COUNTRY_CODE = 'CA';
export const US_COUNTRY_CODE = 'US';

export const ZIP_POSTAL_CODE_INPUT_TITLE = 'US: 12345 | CA: A1A 1A1 or A1A1A1';

const US_ZIP_CODE_REGEX = /^\d{5}$/;
const CA_POSTAL_CODE_REGEX = /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/;

/**
 * Normalizes ZIP/postal code values before validation/submission.
 * For CA, strips extra spaces, uppercases, and formats 6 chars as `A1A 1A1`.
 * For US, returns the trimmed value as-is.
 */
export const normalizeZipOrPostalCode = (value: string, country?: string) => {
  const trimmedValue = value.trim();

  if (country === CA_COUNTRY_CODE) {
    const compactValue = trimmedValue.replace(/\s+/g, '').toUpperCase();

    if (compactValue.length === 6) {
      return `${compactValue.slice(0, 3)} ${compactValue.slice(3)}`;
    }

    return compactValue;
  }

  return trimmedValue;
};

export const getZipOrPostalCodeValidationError = (
  value: string,
  country?: string,
) => {
  if (!value) return undefined;

  if (country === CA_COUNTRY_CODE) {
    // Validate raw input before normalization to reject multiple spaces
    if (!CA_POSTAL_CODE_REGEX.test(value.trim())) {
      return new Error(
        'Please enter a valid Canadian postal code (accepted: A1A 1A1 or A1A1A1).',
      );
    }
  }

  const formattedValue = normalizeZipOrPostalCode(value, country);

  if (country === US_COUNTRY_CODE && !US_ZIP_CODE_REGEX.test(formattedValue)) {
    return new Error('Please enter a valid US ZIP code (accepted: 12345).');
  }

  return undefined;
};
